<script setup lang="ts">
import { ref, withDefaults } from "vue"
import i18n from '@/lang/i18n';
import ConfirmationModal from "@/components/Common/ConfirmationModalBase.vue";

type Props = {
  modalState: boolean,
  loading?: boolean,
  title: string,
  note: string,
  rightBtnName: string
};

const props = withDefaults(defineProps<Props>(), {
  modalState: false,
});

const emits = defineEmits(['confirm', 'cancel'])

function confirm() {
  emits("confirm");
}

function cancel() {
  emits("cancel");
}
</script>

<template>
  <ConfirmationModal
    :title="props.title"
    :note="props.note"
    :modalState="props.modalState"
    :rightBtnName="props.rightBtnName"
    rightBtnClass="bg-warning"
    @rightBtnAction="confirm"
    :leftBtnName="i18n.global.t('common.cancelBtn')"
    leftBtnClass="reset-btn"
    @leftBtnAction="cancel"
    modalMaxWidth="40%"
    :rightLoading="props.loading"
  />
</template>
